/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AddAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Add from './Add/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function AddAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Charges/AddAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 marginTop={0}
 marginLeft={dtSpaceXs}
 type="primary"
 size="normal"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Add/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Add/Content'))}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Add new charge"
 marginLeft={dtSpaceXxs}
/>
)}
</TysiaButton>
<Add
  viewPath={`${viewPath}/Add`}
/>
{children}
</React.Fragment>)
}